module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo/leo_pn-1d3aaf81910a2688e9df02cfc4b5adf3.gif";